import { Box, Divider, Flex, Image, useToast, VStack } from '@chakra-ui/react';
import React, { useContext, useEffect, useState } from 'react';
import {
  AiOutlineFileText,
  AiOutlineMenu,
  AiOutlineUser,
} from 'react-icons/ai';
import { useTranslation } from 'react-i18next';
import { BsGear, BsPercent, BsShieldCheck, BsTagsFill } from 'react-icons/bs';
import { CgList } from 'react-icons/cg';
import { ImMobile } from 'react-icons/im';
import cms from '../../apis/cms';
import useAuth from '../../hooks/useAuth';
import { MenuLocationsContext } from '../../hooks/useMenuItemsLocation';
import NavGroup from './NavGroup';
import NavItem from './NavItem';

const Aside: React.FC = () => {
  const [logo, setLogo] = useState('');
  const { user } = useAuth();
  const isSysAdmin = user?.roles.includes('sysadmin');

  const { data: dataFromContext } = useContext(MenuLocationsContext);

  const toast = useToast();
  const { t } = useTranslation();

  async function getLogo() {
    try {
      const { data } = await cms.rest.get<any>('/config-images/image_menu', {
        params: {
          withFile: true,
        },
      });
      setLogo(data?.file?.url);
    } catch (err: any) {
      toast({
        title: 'Opss!!',
        description:
          err?.response?.data?.message ||
          'Ocorreu um erro ao carregas a telas, tente novamente mais tarde!',
        status: 'error',
        position: 'top-right',
      });
    }
  }

  useEffect(() => {
    getLogo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex
      py="20px"
      h="100vh"
      maxH="100svh"
      overflowY="auto"
      as="aside"
      flexDir="column"
      w={225}
      zIndex={20}
      boxShadow="xl"
    >
      {logo ? (
        <Box px="20px" mb={6}>
          <Image src={logo} mb="16px" />
          <Divider />
        </Box>
      ) : (
        ''
      )}

      <VStack as="nav" spacing={0}>
        <>
          <NavItem icon={AiOutlineUser} title={t('users')} to="/users" />
          <NavItem
            icon={ImMobile}
            title={t('pagesTitle')}
            to="/dynamic_pages"
          />
          <NavItem
            icon={BsTagsFill}
            title={t('customTags.title')}
            to="/customTag"
          />
          <NavGroup
            icon={AiOutlineMenu}
            title={t('menuItemsTitle')}
            items={dataFromContext?.map((location: any) => ({
              title: location?.name,
              to: `/menu-items/${location?.slug}`,
            }))}
          />
          <NavItem
            icon={AiOutlineFileText}
            title={t('menuItemsLocationTitle')}
            to="/menu-items-location"
          />
          <NavItem
            icon={CgList}
            title={t('dynamicShowcaseTitle')}
            to="/dynamic_showcase"
          />
          <NavItem
            icon={BsPercent}
            title={t('couponsTitlePanel')}
            to="/coupons"
          />
          <NavItem icon={BsGear} title={t('config')} to="/configs" />
          {isSysAdmin && (
            <>
              <NavItem
                icon={BsShieldCheck}
                title={t('adminTitlePanel')}
                to="/cmsadmin"
                borderTop="2px"
                borderColor="gray.200"
              />
            </>
          )}
        </>
      </VStack>
    </Flex>
  );
};

export default Aside;
